import { render, staticRenderFns } from "./JChartTabStyle.vue?vue&type=template&id=542dec3e&"
import script from "./JChartTabStyle.vue?vue&type=script&lang=js&"
export * from "./JChartTabStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports